import OrderDTO from "@/dto/order/OrderDTO";
import { observer } from "mobx-react-lite";
import React from "react";

interface OrderOnHoldInfoProps {
    order: OrderDTO;
}

export function shouldRenderOrderOnHoldInfo(order: OrderDTO) {
    return !!(order.isOnHold && (order.holdRestoreDate || order.holdRemarks));
}

/**
 * 挂起订单，恢复日期及备注
 */
const OrderOnHoldInfo: React.FC<OrderOnHoldInfoProps> = function (props) {
    const { order } = props;

    let restoreDate = null;
    let holdRemarks = null;

    if (order.isOnHold) {
        if (order.holdRestoreDate) {
            restoreDate = (
                <div>
                    <span className="restore-date">恢复时间：{order.holdRestoreDate}</span>
                </div>
            );
        }

        if (order.holdRemarks) {
            holdRemarks = (
                <div>
                    <span className="hold-remarks">挂起备注：{order.holdRemarks}</span>
                </div>
            );
        }
    }

    return (
        <>
            {holdRemarks}
            {restoreDate}
        </>
    );
};

export default observer(OrderOnHoldInfo);
